import { useCompanyApi } from "./useCompanyApi";
import { useEffect } from "react";

const useRegistrationStepChecker = () => {
  const { company, fetchCompany } = useCompanyApi();

  useEffect(() => {
    fetchCompany();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (company) {
      const step = company.registration_step;

      const { pathname } = window.location;

      if (step !== "completed" && pathname !== "/callback") {
        if (!step && !pathname.includes("/onboarding/website-url")) {
          window.location.href = "/onboarding/website-url";
        }

        if (
          step === "website-url" &&
          !pathname.includes("/onboarding/website-url")
        ) {
          window.location.href = "/onboarding/website-url";
        }

        if (
          step === "upload-content" &&
          !pathname.includes("/onboarding/upload-content")
        ) {
          window.location.href = "/onboarding/upload-content";
        }

        if (step === "test" && !pathname.includes("/onboarding/test")) {
          window.location.href = "/onboarding/test";
        }

        if (
          step === "subscription" &&
          !pathname.includes("/onboarding/subscription")
        ) {
          window.location.href = "/onboarding/subscription";
        }
      }
    }
  }, [company]);
};

export default useRegistrationStepChecker;
